// import { toastApp } from '@/components/toast-message/sonner';
import { HistoryTradeItem } from '@/hooks/useGetHistory';
import { useCheckClosePair } from '@/hooks/useCheckClosePair';
// import { useAddress } from '@/store/selector';
import { formatDisplay } from '@/utils/format-display';
import { numberFormat } from '@/utils/numberFormat';
// import BigNumber from 'bignumber.js';
import clsx from 'clsx';
import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
// import { useNavigate } from 'react-router';
import SheetDetail from './sheet-detail';
// import { useBalance } from '@/hooks/useBalance';
// import { OpenTrade } from '@/components/trading/open-trade';
// import { OrderType, Type } from '@/components/trading/type';
import { percentage } from '@/hooks/useGetPosition';

type Props = {
    item: HistoryTradeItem;
};

const MAP_TYPE = {
    0: {
        title: 'Take profit',
        color: '#38F24A',
        bg: 'rgba(56, 242, 74, 0.10)',
    },
    1: {
        title: 'Stop Loss',
        color: '#FF695F',
        bg: 'rgba(255, 105, 95, 0.10)',
    },

    2: {
        title: 'Liquidated',
        color: '#FF695F',
        bg: 'rgba(255, 105, 95, 0.10)',
    },
} as Record<number, { title: string; color: string; bg: string }>;

export default function Item({ item }: Props) {
    const { t } = useTranslation();

    const [isOpenDetail, setIsOpenDetail] = useState(false);

    // const [isLoading, setIsLoading] = useState(false);

    const { isClose } = useCheckClosePair(Number(item.pairIndex));

    // const navigate = useNavigate();

    // const address = useAddress();

    // const { data: usdcBalance } = useBalance();

    const handleOpen = useCallback(() => {
        setIsOpenDetail(true);
    }, []);

    const handleCloseDetail = useCallback(() => {
        setIsOpenDetail(false);
    }, []);

    // const handleReopenOrder = async (isBuy: boolean) => {
    //     if (
    //         new BigNumber(usdcBalance?.toString() ?? '0').lt(
    //             item.collateralBeforeFee
    //         )
    //     ) {
    //         return toastApp.error(t('Not enough balance'));
    //     }

    //     setIsLoading(true);
    //     await OpenTrade({
    //         address,
    //         buy: isBuy,
    //         onSuccess: () => {
    //             navigate('/orders?tab=Position', {
    //                 state: { isOpened: true },
    //             });
    //         },
    //     })({
    //         pairIndex: item.pairIndex.toString(),
    //         leverage: item.leverage,
    //         amount: new BigNumber(item.collateralBeforeFee)
    //             .dividedBy(1e18)
    //             .toString(),
    //         orderType: OrderType.Market,
    //         tp: '',
    //         sl: '',
    //         type: isBuy ? Type.Long : Type.Short,
    //         limitPrice: '',
    //     });

    //     setIsLoading(false);
    // };

    const orderType = useMemo(() => {
        if (item.orderType === null) {
            return {
                title: 'Closed',
                color: '#fff',
                bg: 'rgba(255, 255, 255, 0.10)',
            };
        }
        return MAP_TYPE[item.orderType];
    }, [item.orderType]);

    return (
        <div
            className="rounded-xl p-4 shadow-sm border border-gray-100 cursor-pointer bg-white"
            onClick={handleOpen}
        >
            <div className="flex justify-between items-start mb-3">
                <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center shrink-0">
                        <img
                            src={item.logoUrl}
                            alt={item.symbol}
                            className="w-10 h-10 rounded-full"
                        />
                    </div>
                    <div>
                        <div className="flex items-center space-x-2">
                            <span className="font-bold text-base text-gray-900 ">
                                {item.nameDisplay}
                            </span>
                        </div>
                        <div className="flex items-center space-x-2">
                            <span
                                className={clsx(
                                    'px-1.5 py-0.5 text-[10px] font-bold rounded-full border uppercase',
                                    {
                                        'bg-[#22c55e]/10 text-[#22c55e] border-[#22c55e]/20':
                                            item.buy,
                                        'bg-[#ef4444]/10 text-[#ef4444] border-[#ef4444]/20':
                                            !item.buy,
                                    }
                                )}
                            >
                                {item.buy ? 'Long' : 'Short'}
                            </span>
                            <span className="text-[10px] font-semibold text-gray-400 border border-gray-200 px-1.5 py-px rounded-full">
                                {item.leverage}x
                            </span>
                        </div>
                    </div>
                </div>
                <div className="text-right">
                    <div
                        className={clsx('text-sm font-bold', {
                            'text-[#22c55e]': item.pnlNumber >= 0,
                            'text-[#ef4444]': item.pnlNumber < 0,
                        })}
                    >
                        {item.pnlNumber > 0 ? '+' : ''}
                        {formatDisplay(item.pnlNumber, {
                            decimalToShow: 2,
                        })}{' '}
                        WLD
                    </div>
                    <div
                        className={clsx('text-xs font-bold', {
                            'text-[#22c55e]': item.pnlPercent >= 0,
                            'text-[#ef4444]': item.pnlPercent < 0,
                        })}
                    >
                        {percentage(item.pnlPercent)}
                    </div>
                </div>
            </div>
            <div className="grid grid-cols-3 gap-4 pt-3 border-t border-gray-50">
                <div>
                    <div className="text-[10px] font-medium text-[#64748B] mb-0.5">
                        {t('Amount')}
                    </div>
                    <div className="text-xs font-semibold text-gray-700">
                        {numberFormat(
                            Number(item.initialPosToken) /
                                Math.pow(10, item.decimals)
                        )}{' '}
                        WLD
                    </div>
                </div>
                <div className="text-center">
                    <div className="text-[10px] font-medium text-[#64748B] mb-0.5">
                        {t('Entry Price')}
                    </div>
                    <div className="text-xs font-semibold text-gray-700">
                        {formatDisplay(
                            Number(item.openPrice) / Math.pow(10, 10),
                            {
                                decimalToShow: item.decimalToShow,
                            }
                        )}
                    </div>
                </div>
                <div className="text-right">
                    <div className="text-[10px] font-medium text-[#64748B] mb-0.5">
                        {t('Close Price')}
                    </div>
                    <div className="text-xs font-semibold text-gray-700">
                        {formatDisplay(
                            Number(item.closePrice) / Math.pow(10, 10),
                            {
                                decimalToShow: item.decimalToShow,
                            }
                        )}
                    </div>
                </div>
            </div>
            <div className="flex justify-end mt-3">
                <span
                    className={clsx(
                        `inline-flex items-center px-2 py-0.5 rounded-full text-[10px]
                         font-bold  uppercase`,
                        {
                            'bg-red-50 text-red-600 border border-red-100':   orderType.title === 'Liquidated',
                            'bg-gray-100 text-gray-500 border border-gray-200':  orderType.title !== 'Liquidated',
                        }
                    )}
                >
                    {t(orderType.title)}
                </span>
            </div>
            {isOpenDetail && (
                <SheetDetail
                    item={item}
                    isClose={isClose}
                    isOpen={isOpenDetail}
                    onClose={handleCloseDetail}
                />
            )}
        </div>
    );
}
